export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: 'c32a080f-459b-44a3-8258-76aef9532246',

  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'com',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'volvocarprivilege.vivofacil',

  /**
  * Nombre de la app
  */
  appName: 'Volvo Car Privilege',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Vivofácil',

  /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'vivofacil',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-8TCHHFKS3S',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: true,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false,

  /** numero de telefono o false. Si es false no se muestra el icono de whatsapp en las páginas */
  whatsapp: false,

  /** true of false. Define si se muestra el botón para volver al inicio */
  homeButton: true,

  /** true o false. Define si se muestra el area privada */
  showPrivateArea: false,

  /** Se permiten contraseñas no seguras */
  allowInsecurePasswords: false,

  /**
   * Api Key de Google Maps
   * Valores: false|<clave_publica>
   */
  googleMapsApiKey: 'false',

  /** testamentis */
  testamentisHereditary: 'https://formularios.alares.local/form/create/1edaeaf3-6bc3-651c-ae2c-1b9a90d4d278/embed',
  testamentisLiving: 'https://formularios.alares.local/form/create/1ed08dea-bf79-6442-8808-436f6414e40d/embed',
  contactFormPublicUuid: '6dd9166a-e99a-4c24-bebd-d52c0969e1f5',
  showPublicContactChannels: false
};
